/* eslint-disable regex/invalid */
import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

/**
 * Only meant for our checkbox component!
 */
export const CheckboxChecked: FC<SvgIconProps> = (props) => (
  <SvgIcon width="20" height="20" {...props}>
    <path
      d="M0 3C0 1.34315 1.34315 0 3 0H21C22.6569 0 24 1.34315 24 3V21C24 22.6569 22.6569 24 21 24H3C1.34315 24 0 22.6569 0 21V3Z"
      fill="currentColor"
    />
    <path
      d="M9.50001 15.475L6.02501 12L4.84167 13.175L9.50001 17.8333L19.5 7.83333L18.325 6.65833L9.50001 15.475Z"
      fill="white"
    />
  </SvgIcon>
)
